// extracted by mini-css-extract-plugin
module.exports = {"header":"RecentlyDeceased_header__qUDba","header__item":"RecentlyDeceased_header__item__n0e03","recent":"RecentlyDeceased_recent__VJKxD"};